<template>
<span>
<span v-if="!noLabel"> <b>State</b><br/></span>
     <v-autocomplete :attach="attach"
        class="mr-2 pt-1" 
        outline
        type="text" 
       
        hide-details 
        data-vv-name="state_id" 
        item-text="name" 
        item-value="id" 
        :items="states" 
        @input= "stateSelected"
        :placeholder="noLabel ? 'State' : ''"
        :error-messages="errors.collect('state_id')"
        v-model="state"
        :disabled ="!countryId"
    /> 
</span>
</template>
<script>
import States from '@/api/service/States.json';
export default {
    props: [
        "countryId", "state","noLabel", "attach"
    ],
    data() {
        return {
            "stateData":States,
            "states":[]

        }
    },
    watch: {
         countryId:function(val) {
            this.setStates()
        }
    },
    created: function(){
       this.setStates()
    },
    methods: {
        setStates() {
            this.states= States[this.countryId]
        },
        stateSelected($id) {
            this.$emit('stateSelected',$id)
        }
    }
}
</script>